import { render } from "./RiattivazioniKOTable.vue?vue&type=template&id=dacb1f06&scoped=true"
import script from "./RiattivazioniKOTable.vue?vue&type=script&lang=js"
export * from "./RiattivazioniKOTable.vue?vue&type=script&lang=js"

import "./RiattivazioniKOTable.vue?vue&type=style&index=0&id=dacb1f06&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dacb1f06"]])

export default __exports__